import { ResetPasswordType, VerifyTokenResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";

export const ResetPassword = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      sendResetEmail: builder.mutation<
        any,
        { email: string; website_url: string; user_type?: string }
      >({
        query: (forgotpassowordData) => ({
          url: `/forget-password`,
          method: "POST",
          body: forgotpassowordData,
          headers: {
            Accept: "application/json",
          },
          invalidateTags: ["Reset"],
        }),
      }),
      verifyToken: builder.query<VerifyTokenResponse, string>({
        query: (token) => ({
          url: `/reset-password/${token}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          providesTags: ["Reset"],
        }),
      }),
      resetPassword: builder.mutation<any, ResetPasswordType>({
        query: (resetPasswordData) => ({
          url: `/reset-password`,
          method: "POST",
          body: resetPasswordData,
          headers: {
            Accept: "application/json",
          },
          invalidateTags: ["Reset"],
        }),
      }),
    };
  },
});

export const {
  useSendResetEmailMutation,
  useVerifyTokenQuery,
  useResetPasswordMutation,
} = ResetPassword;
